import { graphql } from 'gatsby';
import React from 'react';

import {
  Drupal_FieldParagraphNineteenBannerFieldNineteenTextCta,
  Drupal_ParagraphNineteenBanner,
  Drupal_ParagraphNineteenTextCta
} from '../../../generated/graphql';
import NineteenCta, { nineteenCtaThemes } from '../nineteen-cta/nineteen-cta';
import './nineteen-banner.scss';

interface Props {
  entity: Drupal_ParagraphNineteenBanner;
}

const NineteenBanner = ({
  entity: { fieldHeader, fieldText, fieldNineteenTextCta }
}: Props) => (
  <section className="nineteen-banner">
    <div className="lucid-container">
      <h2 className="nineteen-banner__header">{fieldHeader}</h2>
      <p className="nineteen-banner__body">{fieldText}</p>
      {(fieldNineteenTextCta as Drupal_FieldParagraphNineteenBannerFieldNineteenTextCta[]).map(
        ({ entity }, index) => {
          const {
            entityId,
            fieldHeading,
            fieldSingleCta
          } = entity as Drupal_ParagraphNineteenTextCta;
          const isPrimary = index % 2 !== 0;
          return (
            <p className="nineteen-banner__cta" key={entityId!}>
              {fieldHeading}
              {fieldSingleCta && (
                <NineteenCta
                  primary={isPrimary}
                  inverse
                  theme={nineteenCtaThemes.inline}
                  entity={fieldSingleCta.entity!}
                />
              )}
            </p>
          );
        }
      )}
    </div>
  </section>
);

export default NineteenBanner;

export const query = graphql`
  fragment nineteenBanner on Drupal_ParagraphNineteenBanner {
    fieldHeader
    fieldText
    fieldNineteenTextCta {
      entity {
        ...nineteenTextCta
      }
    }
  }
`;
